module.exports = __webpack_public_path__ + "static/media/2.ef54e29e.jpg";